(function() { window.GUID_f641a000_305f_48b5_9509_1f1e578df230 = { getGuid: function() { return "f641a000-305f-48b5-9509-1f1e578df230"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TopBarSlideOut {
            static Show(params) {
                if (params != null) {
                    if (params.Id != null && params.Id.trim() != "") {
                        CS.Lag("topbarslideout", 50, () => {
                            new TopBarSlideOut(params);
                        });
                    }
                }
            }
            constructor(params) {
                this.show(params);
            }
            show(params) {
                let me = this;
                let $sectionTop = CS.DOM.$body.find(".section-top").last();
                if ($sectionTop.length > 0) {
                    this.$topBarSlideOut = $(TopBarSlideOut.createElement(params));
                    $sectionTop.prepend(this.$topBarSlideOut);
                    this.$topBarSlideOut.offon("click.topbarslideout", (e) => {
                        me.hide();
                    });
                    this.$topBarSlideOut.slideDown(300, () => {
                        setTimeout(() => {
                            me.hide();
                        }, params.AutoHideDuration);
                    });
                }
            }
            hide() {
                let me = this;
                me.$topBarSlideOut.off("click.topbarslideout");
                me.$topBarSlideOut.slideUp(150, () => {
                    me.$topBarSlideOut.remove();
                });
            }
            static createElement(params) {
                let containerCssClass = "topbarslideout-container";
                let contentCssClass = "topbarslideout";
                let txtCssClass = "topbarslideout__txt";
                let closeIconCssClass = "topbarslideout__close-icon icon ic-cs-times";
                const msg = params.Message;
                const htmlDecodedMessage = msg.replace(/\/u003c/g, "<").replace(/\/u003e/g, ">").replace(/\/u0027/g, "'");
                return `<div id="${params.Id}" class="${containerCssClass}" style="display:none;">
                        <div class="${contentCssClass}">
                            <div class="${txtCssClass}">${htmlDecodedMessage}</div>
                            <div class="${closeIconCssClass}"></div>
                        </div>
                    </div>`;
            }
        }
        Controls.TopBarSlideOut = TopBarSlideOut;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=topbarslideout.js.map
